class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.classList.add("shopify-section-header-sticky");

    this.onScrollHandler = this.onScroll.bind(this);
    window.addEventListener("scroll", this.onScrollHandler, { passive: true });
    this.onScroll();

    this.initMobileSearchToggle();
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > 80) {
      this.classList.add("header-scrolled");
    } else {
      this.classList.remove("header-scrolled");
    }
  }

  initMobileSearchToggle() {
    this.searchToggleMobile = this.querySelector(
      ".site-header__search-toggle--mobile",
    );
    this.mobileSearchBar = document.getElementById("MobileSearchBar");

    if (this.searchToggleMobile && this.mobileSearchBar) {
      this.searchToggleMobile.addEventListener("click", (e) => {
        e.preventDefault();

        const isExpanded =
          this.searchToggleMobile.getAttribute("aria-expanded") === "true";

        this.searchToggleMobile.setAttribute("aria-expanded", !isExpanded);

        this.mobileSearchBar.classList.toggle("is-active");
        this.mobileSearchBar.classList.remove(
          "site-header__search-wrapper--hidden",
        );

        if (!isExpanded) {
          setTimeout(() => {
            const searchInput = this.mobileSearchBar.querySelector(
              'input[type="search"], input[name="q"]',
            );
            if (searchInput) searchInput.focus();
          }, 100); 
        }
      });
    }
  }
}

customElements.define("sticky-header", StickyHeader);

class MobileMenuDrawer extends HTMLElement {
  connectedCallback() {
    this.overlay = document.querySelector(".menu-drawer__overlay");
    this.openButtons = document.querySelectorAll(".site-header__menu-button");
    this.closeButton = this.querySelector(".menu-drawer__close-button");

    this.openButtons.forEach((btn) => {
      btn.addEventListener("click", () => this.open());
    });

    if (this.closeButton) {
      this.closeButton.addEventListener("click", () => this.close());
    }

    if (this.overlay) {
      this.overlay.addEventListener("click", () => this.close());
    }

    document.addEventListener("keyup", (event) => {
      if (
        event.code.toUpperCase() === "ESCAPE" &&
        document.body.classList.contains("menu-drawer-open")
      ) {
        this.close();
      }
    });
  }

  open() {
    document.body.classList.add("menu-drawer-open");
    this.openButtons.forEach((btn) =>
      btn.setAttribute("aria-expanded", "true"),
    );
  }

  close() {
    document.body.classList.remove("menu-drawer-open");
    this.openButtons.forEach((btn) =>
      btn.setAttribute("aria-expanded", "false"),
    );
  }
}

customElements.define("mobile-menu-drawer", MobileMenuDrawer);
